import styled from "styled-components";

export const Label = styled.div`
  font-size: 13px;
  line-height: 15px;
  color: #444444;
  margin-top: 11px;
  margin-bottom: 11px;
`;
